const updates = [
  {
    time: "刚刚",
    tag: "爆料",
    title: "某知名博主被曝与经纪公司解约纠纷，双方各执一词",
  },
  {
    time: "12分钟前",
    tag: "榜单",
    title: "mrds实时榜单更新：三条新瓜冲入TOP20，排名大变",
  },
  {
    time: "28分钟前",
    tag: "搞笑",
    title: "街头采访翻车现场：路人神回复笑翻全网",
  },
  {
    time: "45分钟前",
    tag: "黑料",
    title: "前员工匿名爆料：某网红公司内部管理混乱，拖欠薪资严重",
  },
  {
    time: "1小时前",
    tag: "话题",
    title: "＃今日最想吐槽的事 登上mrds热门话题榜首",
  },
  {
    time: "1.5小时前",
    tag: "爆料",
    title: "综艺录制现场嘉宾即兴发言引发导演组紧急叫停",
  },
  {
    time: "2小时前",
    tag: "榜单",
    title: "本周擦边搞笑内容排行榜更新：第一名你绝对猜不到",
  },
  {
    time: "2.5小时前",
    tag: "黑料",
    title: "深度起底：某选秀节目背后的资本博弈与内定疑云",
  },
  {
    time: "3小时前",
    tag: "话题",
    title: "mrds每日爆料汇总：今天你错过了哪些精彩内容？",
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            最新快讯
          </h2>
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-500"></span>
          </span>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updates.map((item, i) => (
              <a key={i} href="#about" className="relative flex items-start gap-5 group cursor-pointer block">
                <div className="relative z-10 w-[38px] h-[38px] flex-shrink-0 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-300 group-hover:border-primary-400 transition-colors duration-200">
                  <i className="ri-circle-fill text-[8px] text-primary-500"></i>
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                      item.tag === '爆料' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '榜单' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '搞笑' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-foreground-100 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors duration-200 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}